import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { TextLink } from '@vds/buttons';

import ReqInput from '../../common/ReqInput';
import { selectStateCache } from '../@Redux/selectors/checkout.selectors';
import { useCheckoutHooks } from '../ExpressCheckout/@Redux/checkout.hooks';
import { getSession, isExpressCheckout } from '../../common/Helpers';

const PromoCode = (props) => {
  const { onClickPromo } = props;
  const [couponStatusCode, setcouponStatusCode] = useState(false);
  const [showCouponCodeTextField, setshowCouponCodeTextField] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const sessionStorageHasCouponToken = getSession('couponToken');
  // const [couponCodevalue, setCouponCodevalue] = useState('');
  const [invalidCode, setInvalidCode] = useState(false);
  const [errorCodeText, setErrorCodeText] = useState('');

  const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const { isValidPromoResponse } = useCheckoutHooks(stateCache);
  console.log('super', isValidPromoResponse);
  const { message, notifyMessage } = isValidPromoResponse;

  useEffect(() => {
    if (message === 'VALID') {
      setcouponStatusCode(true);
    } else if (message === 'PROMO CODE INVALID') {
      setInvalidCode(true);
      setErrorCodeText(notifyMessage);
    }
  }, [isValidPromoResponse]);

  const showPromoTextField = () => {
    setshowCouponCodeTextField(true);
    if (showCouponCodeTextField) {
      document.getElementById('promo').focus();
    }
  };

  const onPromoCodeEdit = (value) => {
    setCouponCode(value);
  };

  const clickApply = () => {
    const trimmedCouponCode = couponCode.trim();
    if (!trimmedCouponCode) {
      setInvalidCode(false);
      setErrorCodeText('');
    } else if (trimmedCouponCode < 10) {
      setInvalidCode(true);
      document.getElementById('promo').focus();
      setErrorCodeText('Please enter a valid promo code.');
    } else {
      onClickPromo(couponCode);
    }
  };

  return (
    <>
      {!showCouponCodeTextField ? (
        <TextLink
          style={{ placeSelf: 'start' }}
          ariaLabel="Opens a text box for entering promocode: Add Promo code"
          onClick={() => showPromoTextField()}
          onKeyDown={() => showPromoTextField()}
          tabIndex="0"
          type="standAlone"
          id="AddPromoCode"
          analyticstrack="promo text link"
          data-track='{"type":"link","name":"Opens a text box for entering promocode: Add Promo code|Order summary","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}'
        >
          Add promo code
        </TextLink>
      ) : (
        <div className="couponcodeInput">
          <ReqInput
            type={couponStatusCode ? 'text' : 'inlineAction'}
            label="Enter your promo code"
            readOnly={false}
            id="promo"
            required={false}
            success={couponStatusCode}
            error={invalidCode}
            value={couponStatusCode ? couponCode : sessionStorageHasCouponToken}
            onChange={(e) => onPromoCodeEdit(e.target.value)}
            onClickInlineAction={clickApply}
            successText="Promo code applied"
            maxLength={16}
            errorText={errorCodeText}
            width="100%"
          />
        </div>
      )}
    </>
  );
};
PromoCode.propTypes = {
  onClickPromo: PropTypes.func,
};

export default PromoCode;
